import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Mountain } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back, ascender.");
      nav("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex relative z-10 bg-[var(--bg)] text-[var(--text)]">
      <div className="hidden lg:block lg:w-1/2 relative border-r border-[var(--border)] overflow-hidden">
        <img
          src="https://images.pexels.com/photos/8671511/pexels-photo-8671511.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=900"
          alt="Ascend"
          className="absolute inset-0 w-full h-full object-cover grayscale opacity-70"
        />
        <div className="absolute inset-0 bg-gradient-to-tr from-black/90 via-black/30 to-transparent" />
        <div className="absolute bottom-10 left-10 right-10">
          <span className="tape-label">SECURE TERMINAL</span>
          <h2 className="font-display text-6xl mt-4 leading-none">
            WELCOME<br />BACK,<br />ASCENDER.
          </h2>
        </div>
      </div>

      <div className="w-full lg:w-1/2 flex flex-col">
        <div className="p-6 border-b border-[var(--border)] flex justify-between items-center">
          <Link to="/" className="flex items-center gap-2" data-testid="login-brand">
            <Mountain className="w-5 h-5 text-[var(--primary)]" />
            <span className="font-display text-2xl tracking-wider">ASCEND</span>
          </Link>
          <Link to="/register" className="text-xs font-mono uppercase tracking-widest text-[var(--text-muted)] hover:text-white" data-testid="login-to-register">
            No account? Register →
          </Link>
        </div>

        <div className="flex-1 flex items-center justify-center p-6">
          <form onSubmit={submit} className="w-full max-w-md">
            <span className="tape-label">SIGN IN</span>
            <h1 className="font-display text-5xl mt-4 mb-8 leading-none">ENTER<br />THE PROTOCOL.</h1>

            <div className="space-y-5">
              <div>
                <label className="block text-[10px] font-mono uppercase tracking-widest text-[var(--text-muted)] mb-2">Email</label>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="brutal"
                  data-testid="login-email-input"
                  placeholder="you@ascend.gg"
                />
              </div>
              <div>
                <label className="block text-[10px] font-mono uppercase tracking-widest text-[var(--text-muted)] mb-2">Password</label>
                <input
                  type="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="brutal"
                  data-testid="login-password-input"
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                className="btn-brutal w-full"
                data-testid="login-submit-button"
              >
                {loading ? "Authenticating..." : "Sign In →"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
